import ContextSelection from '@/components/_core/ui/context-selection';
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { ACCESS_LEVEL } from '~/constants/_core/access-level';
import { OWNER } from '~/constants/_core/owner';

export default Vue.extend({
  components: {
    ContextSelection
  },
  data() {
    return {
      isOpen                   : false,
      isContextNameOverflowing : false
    };
  },
  created() {
    this.ACCESS_LEVEL = ACCESS_LEVEL;
  },
  computed: {
    ...mapGetters({
      currentAccessLevel : '_core/user/getCurrentAccessLevel',
      isImpersonated     : '_core/auth/isImpersonated'
    }),
    ...mapState({
      currentContext : state => state._core.user.currentContext,
      contexts       : state => state._core.user.contexts,
      owner          : state => state._core.application.owner,
      isOperation    : state => state._core.application.isOperation
    }),
    canChangeContext() {
      if (this.owner === OWNER.IES) {
        return false;
      }

      let totalContexts = 0;
      for (const context of this.contexts) {
        if (context.canAccess || context.level === ACCESS_LEVEL.APPLICATION) {
          totalContexts++;
        }
        totalContexts += context.institutions?.length ?? 0;
      }

      return totalContexts > 1;
    },
    context() {
      if (this.currentAccessLevel === ACCESS_LEVEL.APPLICATION) {
        return {
          name: this.$t('_core.contextSelection.application')
        };
      }

      const tenant = this.contexts.find(ctx => ctx.uuid === this.currentContext.tenant?.uuid);
      if (this.currentAccessLevel === ACCESS_LEVEL.INSTITUTION) {
        const institution = tenant.institutions.find(ctx => ctx.uuid === this.currentContext.institution?.uuid);
        return {
          subtitle : this.$t('_core.contextSelection.institution.title'),
          name     : institution.name
        };
      }

      return {
        subtitle : this.$t('_core.contextSelection.tenant.title'),
        name     : tenant.name
      };
    }
  },
  methods: {
    onClick() {
      this.$emit('menu-close');
      this.isOpen = !this.isOpen;
    },
    checkIfContextNameHasOverflowed() {
      if (this.currentAccessLevel === ACCESS_LEVEL.APPLICATION) {
        return;
      }

      const el = this.$refs.contextName;
      this.isContextNameOverflowing = el.scrollHeight > el.clientHeight;
    }
  }
});
